// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/svg/checked.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: var(--color-border-primary, #cbd5e0); /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: var(--color-text-secondary, #a0aec0); /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
html {
    font-family: 'Poppins', sans-serif !important;
    font-feature-settings: 'kern' !important;
    -webkit-font-smoothing: antialiased;
    letter-spacing: -0.5px;
  }
.container{
  width: 100%;
}
@media (min-width: 576px){
  .container{
    max-width: 576px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 992px){
  .container{
    max-width: 992px;
  }
}
@media (min-width: 1200px){
  .container{
    max-width: 1200px;
  }
}
@media (min-width: 1320px){
  .container{
    max-width: 1320px;
  }
}
@media (min-width: 1600px){
  .container{
    max-width: 1600px;
  }
}
@media (min-width: 1850px){
  .container{
    max-width: 1850px;
  }
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.-inset-1{
  inset: -0.25rem;
}
.inset-0{
  inset: 0px;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-\\[180px\\]{
  left: -180px;
}
.-left-\\[230px\\]{
  left: -230px;
}
.-left-\\[250px\\]{
  left: -250px;
}
.-right-1{
  right: -0.25rem;
}
.-right-2{
  right: -0.5rem;
}
.-start-\\[180px\\]{
  inset-inline-start: -180px;
}
.-start-\\[230px\\]{
  inset-inline-start: -230px;
}
.-start-\\[250px\\]{
  inset-inline-start: -250px;
}
.-top-1{
  top: -0.25rem;
}
.-top-12{
  top: -3rem;
}
.-top-2{
  top: -0.5rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-24{
  bottom: 6rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.bottom-\\[30px\\]{
  bottom: 30px;
}
.end-0{
  inset-inline-end: 0px;
}
.end-4{
  inset-inline-end: 1rem;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-10{
  left: 2.5rem;
}
.left-5{
  left: 1.25rem;
}
.right-0{
  right: 0px;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-6{
  right: 1.5rem;
}
.right-\\[0\\.5\\%\\]{
  right: 0.5%;
}
.right-\\[35px\\]{
  right: 35px;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-10{
  top: 2.5rem;
}
.top-11{
  top: 2.75rem;
}
.top-12{
  top: 3rem;
}
.top-16{
  top: 4rem;
}
.top-2{
  top: 0.5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-5{
  top: 1.25rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[0\\.5\\%\\]{
  top: 0.5%;
}
.top-px{
  top: 1px;
}
.\\!z-50{
  z-index: 50 !important;
}
.\\!z-\\[99\\]{
  z-index: 99 !important;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100000\\]{
  z-index: 100000;
}
.z-\\[1000\\]{
  z-index: 1000;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[5\\]{
  z-index: 5;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.float-right{
  float: right;
}
.m-1{
  margin: 0.25rem;
}
.m-auto{
  margin: auto;
}
.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-\\[12px\\]{
  margin-left: 12px;
  margin-right: 12px;
}
.mx-\\[32px\\]{
  margin-left: 32px;
  margin-right: 32px;
}
.mx-\\[56px\\]{
  margin-left: 56px;
  margin-right: 56px;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5{
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-16{
  margin-top: 4rem;
  margin-bottom: 4rem;
}
.my-2\\.5{
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
.my-\\[12px\\]{
  margin-top: 12px;
  margin-bottom: 12px;
}
.my-\\[3px\\]{
  margin-top: 3px;
  margin-bottom: 3px;
}
.\\!mb-6{
  margin-bottom: 1.5rem !important;
}
.-mr-3{
  margin-right: -0.75rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-7{
  margin-bottom: 1.75rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.mb-9{
  margin-bottom: 2.25rem;
}
.mb-\\[14px\\]{
  margin-bottom: 14px;
}
.mb-\\[40px\\]{
  margin-bottom: 40px;
}
.mb-auto{
  margin-bottom: auto;
}
.mb-px{
  margin-bottom: 1px;
}
.me-1{
  margin-inline-end: 0.25rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.me-4{
  margin-inline-end: 1rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-\\[18px\\]{
  margin-left: 18px;
}
.ml-\\[6px\\]{
  margin-left: 6px;
}
.ml-auto{
  margin-left: auto;
}
.ml-px{
  margin-left: 1px;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-12{
  margin-right: 3rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-2\\.5{
  margin-right: 0.625rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.mr-6{
  margin-right: 1.5rem;
}
.ms-1{
  margin-inline-start: 0.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.ms-4{
  margin-inline-start: 1rem;
}
.ms-\\[6px\\]{
  margin-inline-start: 6px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.mt-\\[-8px\\]{
  margin-top: -8px;
}
.mt-\\[10\\%\\]{
  margin-top: 10%;
}
.mt-\\[20px\\]{
  margin-top: 20px;
}
.mt-\\[36px\\]{
  margin-top: 36px;
}
.mt-\\[3px\\]{
  margin-top: 3px;
}
.mt-\\[50px\\]{
  margin-top: 50px;
}
.mt-\\[58px\\]{
  margin-top: 58px;
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.box-border{
  box-sizing: border-box;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[220px\\]{
  height: 220px;
}
.h-\\[250px\\]{
  height: 250px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[30px\\]{
  height: 30px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[580px\\]{
  height: 580px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[61px\\]{
  height: 61px;
}
.h-\\[700px\\]{
  height: 700px;
}
.h-\\[83px\\]{
  height: 83px;
}
.h-\\[87px\\]{
  height: 87px;
}
.h-\\[90px\\]{
  height: 90px;
}
.h-\\[90vh\\]{
  height: 90vh;
}
.h-auto{
  height: auto;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-\\[160px\\]{
  max-height: 160px;
}
.max-h-\\[250px\\]{
  max-height: 250px;
}
.max-h-\\[500px\\]{
  max-height: 500px;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-full{
  max-height: 100%;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[20px\\]{
  min-height: 20px;
}
.min-h-\\[220px\\]{
  min-height: 220px;
}
.min-h-\\[240px\\]{
  min-height: 240px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[48px\\]{
  min-height: 48px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[550px\\]{
  min-height: 550px;
}
.min-h-\\[84vh\\]{
  min-height: 84vh;
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.\\!w-\\[40\\%\\]{
  width: 40% !important;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/2{
  width: 50%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-5{
  width: 1.25rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[108px\\]{
  width: 108px;
}
.w-\\[120px\\]{
  width: 120px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[20px\\]{
  width: 20px;
}
.w-\\[224px\\]{
  width: 224px;
}
.w-\\[256px\\]{
  width: 256px;
}
.w-\\[30\\%\\]{
  width: 30%;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[30px\\]{
  width: 30px;
}
.w-\\[313px\\]{
  width: 313px;
}
.w-\\[350px\\]{
  width: 350px;
}
.w-\\[355px\\]{
  width: 355px;
}
.w-\\[360px\\]{
  width: 360px;
}
.w-\\[450px\\]{
  width: 450px;
}
.w-\\[49\\%\\]{
  width: 49%;
}
.w-\\[5\\%\\]{
  width: 5%;
}
.w-\\[50\\%\\]{
  width: 50%;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[50px\\]{
  width: 50px;
}
.w-\\[54px\\]{
  width: 54px;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[60\\%\\]{
  width: 60%;
}
.w-\\[600px\\]{
  width: 600px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[69px\\]{
  width: 69px;
}
.w-\\[7\\%\\]{
  width: 7%;
}
.w-\\[70\\%\\]{
  width: 70%;
}
.w-\\[80px\\]{
  width: 80px;
}
.w-\\[83px\\]{
  width: 83px;
}
.w-\\[85px\\]{
  width: 85px;
}
.w-\\[87px\\]{
  width: 87px;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[90vw\\]{
  width: 90vw;
}
.w-\\[93\\%\\]{
  width: 93%;
}
.w-\\[94\\%\\]{
  width: 94%;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[14rem\\]{
  max-width: 14rem;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[420px\\]{
  max-width: 420px;
}
.max-w-\\[480px\\]{
  max-width: 480px;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[85\\%\\]{
  max-width: 85%;
}
.max-w-full{
  max-width: 100%;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-screen-sm{
  max-width: 576px;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-\\[2\\]{
  flex: 2 1;
}
.flex-none{
  flex: none;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.flex-grow{
  flex-grow: 1;
}
.grow{
  flex-grow: 1;
}
.origin-\\[65\\%_0\\%\\]{
  transform-origin: 65% 0%;
}
.origin-\\[75\\%_0\\%\\]{
  transform-origin: 75% 0%;
}
.origin-top{
  transform-origin: top;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-96{
  --tw-translate-x: -24rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4{
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0{
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.85\\]{
  --tw-scale-x: 0.85;
  --tw-scale-y: 0.85;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce{
  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }
  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes ping{
  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.\\!flex-row{
  flex-direction: row !important;
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.\\!justify-between{
  justify-content: space-between !important;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-y-16{
  row-gap: 4rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-x-scroll{
  overflow-x: scroll;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[100px\\]{
  border-radius: 100px;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-\\[20px\\]{
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-3xl{
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-\\[20px\\]{
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.rounded-tl-none{
  border-top-left-radius: 0px;
}
.rounded-tr-none{
  border-top-right-radius: 0px;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[1px\\]{
  border-width: 1px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-\\[4px\\]{
  border-width: 4px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-\\[1px\\]{
  border-bottom-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.\\!border-none{
  border-style: none !important;
}
.\\!border-gray-300{
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}
.\\!border-gray-400{
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}
.border-\\[\\#6a53ff\\]{
  --tw-border-opacity: 1;
  border-color: rgb(106 83 255 / var(--tw-border-opacity, 1));
}
.border-borderPrimary{
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-border-primary, #e2e8f0) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-borderPrimary\\/60{
  border-color: color-mix(in srgb, var(--color-border-primary, #e2e8f0) 60%, transparent);
}
.border-brand-200{
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-brand-200, #A195FD) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-brand-500{
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-brand-500\\/20{
  border-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 20%, transparent);
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(245 57 57 / var(--tw-border-opacity, 1));
}
.border-red-500\\/30{
  border-color: rgb(245 57 57 / 0.3);
}
.border-shadowSecondary{
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-shadow-secondary, #7090b0) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/0{
  border-color: rgb(255 255 255 / 0);
}
.\\!bg-brand-50{
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-brand-50, #E9E3FF) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}
.\\!bg-brand-500{
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}
.\\!bg-copyBtnSurface{
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-copy-btn-surface, #16A34A) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}
.\\!bg-gray-100{
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-surface-secondary, #edf2f7) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}
.\\!bg-surfacePrimary{
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-surface-primary, #ffffff) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}
.\\!bg-surfaceSecondary{
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-surface-secondary, #F4F7FE) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}
.\\!bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#20c0ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(32 192 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4318FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(67 24 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6AD2FF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(106 210 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E0E5F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(224 229 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e0e5f2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(224 229 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e2e8f0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-borderPrimary{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-border-primary, #e2e8f0) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-brand-100{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-100, #C0B8FE) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-brand-400{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-400, #7551FF) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-brand-50{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-50, #E9E3FF) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-brand-50\\/20{
  background-color: color-mix(in srgb, var(--color-brand-50, #E9E3FF) 20%, transparent);
}
.bg-brand-50\\/60{
  background-color: color-mix(in srgb, var(--color-brand-50, #E9E3FF) 60%, transparent);
}
.bg-brand-500{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-brand-500\\/10{
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 10%, transparent);
}
.bg-brand-500\\/5{
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 5%, transparent);
}
.bg-brand-900{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-900, #11047A) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-copyBtnSurface{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-copy-btn-surface, #16A34A) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(23 193 232 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-surface-secondary, #edf2f7) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-text-secondary, #adb5bd) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-gray-800\\/80{
  background-color: color-mix(in srgb, var(--color-text-primary, #252f40) 80%, transparent);
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(23 173 55 / var(--tw-bg-opacity, 1));
}
.bg-green-700{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-lightPrimary{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-light-primary, #F4F7FE) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-lime-500{
  --tw-bg-opacity: 1;
  background-color: rgb(130 214 22 / var(--tw-bg-opacity, 1));
}
.bg-navy-500{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-navy-500, #1b3bbb) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-navy-900\\/60{
  background-color: color-mix(in srgb, var(--color-light-primary, #0b1437) 60%, transparent);
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-pink-400{
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 128 / var(--tw-bg-opacity, 1));
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 57 57 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(245 57 57 / 0.1);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 6 6 / var(--tw-bg-opacity, 1));
}
.bg-surfacePrimary{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-surface-primary, #ffffff) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-surfacePrimary\\/60{
  background-color: color-mix(in srgb, var(--color-surface-primary, #ffffff) 60%, transparent);
}
.bg-surfaceSecondary{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-surface-secondary, #F4F7FE) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-surfaceSecondary\\/20{
  background-color: color-mix(in srgb, var(--color-surface-secondary, #F4F7FE) 20%, transparent);
}
.bg-surfaceSecondary\\/30{
  background-color: color-mix(in srgb, var(--color-surface-secondary, #F4F7FE) 30%, transparent);
}
.bg-surfaceSecondary\\/40{
  background-color: color-mix(in srgb, var(--color-surface-secondary, #F4F7FE) 40%, transparent);
}
.bg-surfaceSecondary\\/50{
  background-color: color-mix(in srgb, var(--color-surface-secondary, #F4F7FE) 50%, transparent);
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-textPrimary{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-text-primary, #1b2559) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}
.bg-textSecondary\\/40{
  background-color: color-mix(in srgb, var(--color-text-secondary, #707eae) 40%, transparent);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/0{
  background-color: rgb(255 255 255 / 0);
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-none{
  background-image: none;
}
.from-\\[\\#868CFF\\]{
  --tw-gradient-from: #868CFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(134 140 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brandLinear{
  --tw-gradient-from: var(--color-brand-linear, #868CFF) var(--tw-gradient-from-position);
  --tw-gradient-to: color-mix(in srgb, var(--color-brand-linear, #868CFF) 0%, transparent) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/50{
  --tw-gradient-from: rgb(255 255 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#432CF3\\]{
  --tw-gradient-to: rgb(67 44 243 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #432CF3 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-blueSecondary{
  --tw-gradient-to: var(--color-blue-secondary, #4318FF) var(--tw-gradient-to-position);
}
.to-brand-500{
  --tw-gradient-to: var(--color-brand-500, #422AFB) var(--tw-gradient-to-position);
}
.to-white\\/10{
  --tw-gradient-to: rgb(255 255 255 / 0.1) var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-clip-border{
  background-clip: border-box;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.object-cover{
  object-fit: cover;
}
.\\!p-4{
  padding: 1rem !important;
}
.\\!p-\\[20px\\]{
  padding: 20px !important;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[16px\\]{
  padding: 16px;
}
.p-\\[20px\\]{
  padding: 20px;
}
.p-\\[26px\\]{
  padding: 26px;
}
.p-\\[5px\\]{
  padding: 5px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-11{
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[20px\\]{
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[30px\\]{
  padding-left: 30px;
  padding-right: 30px;
}
.px-\\[32px\\]{
  padding-left: 32px;
  padding-right: 32px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[10px\\]{
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[11px\\]{
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[12px\\]{
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[20px\\]{
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[30px\\]{
  padding-top: 30px;
  padding-bottom: 30px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-7{
  padding-bottom: 1.75rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pe-2{
  padding-inline-end: 0.5rem;
}
.pe-4{
  padding-inline-end: 1rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-8{
  padding-right: 2rem;
}
.ps-3{
  padding-inline-start: 0.75rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-start{
  text-align: start;
}
.font-dm{
  font-family: DM Sans, sans-serif;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-poppins{
  font-family: Poppins, sans-serif;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[150px\\]{
  font-size: 150px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[33px\\]{
  font-size: 33px;
}
.text-\\[34px\\]{
  font-size: 34px;
}
.text-\\[80px\\]{
  font-size: 80px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.capitalize{
  text-transform: capitalize;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.leading-4{
  line-height: 1rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-9{
  line-height: 2.25rem;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.\\!text-\\[\\#ff0000\\]{
  --tw-text-opacity: 1 !important;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-brand-700{
  --tw-text-opacity: 1 !important;
  color: color-mix(in srgb, var(--color-brand-700, #2111A5) calc(var(--tw-text-opacity, 1) * 100%), transparent) !important;
}
.\\!text-textPrimary{
  --tw-text-opacity: 1 !important;
  color: color-mix(in srgb, var(--color-text-primary, #1b2559) calc(var(--tw-text-opacity, 1) * 100%), transparent) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#0000009f\\]{
  color: #0000009f;
}
.text-\\[\\#1B254B\\]{
  --tw-text-opacity: 1;
  color: rgb(27 37 75 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1b2559\\]{
  --tw-text-opacity: 1;
  color: rgb(27 37 89 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6366F1\\]{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-\\[\\#707EAE\\]{
  --tw-text-opacity: 1;
  color: rgb(112 126 174 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ADB5BD\\]{
  --tw-text-opacity: 1;
  color: rgb(173 181 189 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E3DAFF\\]{
  --tw-text-opacity: 1;
  color: rgb(227 218 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ff0000\\]{
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-brand-100{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-brand-100, #C0B8FE) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-brand-200{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-brand-200, #A195FD) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-brand-500{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-brand-700{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-brand-700, #2111A5) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #adb5bd) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #a3aed0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #707eae) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-primary, #252f40) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-primary, #1b2559) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(23 173 55 / var(--tw-text-opacity, 1));
}
.text-lightPrimary{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-light-primary, #F4F7FE) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-navy-700{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-primary, #1B254B) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(245 57 57 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(234 6 6 / var(--tw-text-opacity, 1));
}
.text-textMuted{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-muted, #a3aed0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-textPrimary{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-primary, #1b2559) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-textPrimary\\/10{
  color: color-mix(in srgb, var(--color-text-primary, #1b2559) 10%, transparent);
}
.text-textPrimary\\/80{
  color: color-mix(in srgb, var(--color-text-primary, #1b2559) 80%, transparent);
}
.text-textSecondary{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #707eae) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/0{
  color: rgb(255 255 255 / 0);
}
.underline{
  text-decoration-line: underline;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.\\!opacity-60{
  opacity: 0.6 !important;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-3xl{
  --tw-shadow: 14px 17px 40px 4px;
  --tw-shadow-colored: 14px 17px 40px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_10px_var\\(--color-shadow-primary\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\)\\]{
  --tw-shadow: 0 4px 10px var(--color-shadow-primary,rgba(0,0,0,0.15));
  --tw-shadow-colored: 0 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-shadow-500{
  --tw-shadow-color: var(--color-shadow-primary, #7090b0);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-shadowPrimary{
  --tw-shadow-color: var(--color-shadow-primary, #7090b0);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-white\\/5{
  --tw-shadow-color: rgb(255 255 255 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\!duration-200{
  transition-duration: 200ms !important;
}
.duration-100{
  transition-duration: 100ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-75{
  transition-duration: 75ms;
}
.duration-\\[0\\.2s\\]{
  transition-duration: 0.2s;
}
.duration-\\[0\\.5s\\]{
  transition-duration: 0.5s;
}
.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.pe-2{
  padding-inline-end: 0.5rem;
}
.ps-3{
  padding-inline-start: 0.75rem;
}
.pe-4{
  padding-inline-end: 1rem;
}
.ms-1{
  margin-inline-start: 0.25rem;
}
.me-1{
  margin-inline-end: 0.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.ms-3{
  margin-inline-start: 0.75rem;
}
.ms-4{
  margin-inline-start: 1rem;
}
.me-4{
  margin-inline-end: 1rem;
}
[dir="rtl"] .end-0{
  left: 0px;
}
[dir="ltr"] .end-0{
  right: 0px;
}
[dir="rtl"] .end-4{
  left: 1rem;
}
[dir="ltr"] .end-4{
  right: 1rem;
}
[dir="rtl"] .text-start{
  text-align: right;
}
[dir="ltr"] .text-start{
  text-align: left;
}

:root {
  /* Default Horizon UI Purple/Blue Theme Colors */
  --color-light-primary: #F4F7FE;
  --color-blue-secondary: #4318FF;
  --color-brand-linear: #868CFF;
  --color-brand-50: #E9E3FF;
  --color-brand-100: #C0B8FE;
  --color-brand-200: #A195FD;
  --color-brand-300: #8171FC;
  --color-brand-400: #7551FF;
  --color-brand-500: #422AFB;
  --color-brand-700: #2111A5;
  --color-brand-900: #11047A;

  /* Button Surfaces and Icons */
  --color-copy-btn-surface: #16A34A;
  --color-copy-btn-icon: #ffffff;
  --color-download-btn-surface: #6495ED;
  --color-download-btn-icon: #ffffff;

  /* Typography */
  --color-text-primary: #1b2559;
  --color-text-secondary: #707eae;
  --color-text-muted: #a3aed0;

  /* Surfaces & Borders */
  --color-surface-primary: #ffffff;
  --color-surface-secondary: #F4F7FE;
  --color-border-primary: #e2e8f0;

  /* Shadows */
  --color-shadow-primary: #7090b0;
  --color-shadow-secondary: #7090b0;

  /* Navy palette (used by dark: variants, themed per-theme) */
  --color-navy-400: #3652ba;
  --color-navy-500: #1b3bbb;
  --color-navy-600: #24388a;
  --color-navy-700: #1B254B;
  --color-navy-800: #111c44;
  --color-navy-900: #0b1437;

  /* Scrollbars */
  --color-scrollbar-thumb: #a3aed0;
  --color-scrollbar-track: #F4F7FE;
}

/* ─── Native form element theming ──────────────────────────────────────────── */
/* Ensures all native <select>, <option>, <input>, <textarea> follow the theme */

select,
select option {
  background-color: var(--color-surface-primary, #ffffff);
  color: var(--color-text-primary, #1b2559);
  border-color: var(--color-border-primary, #e2e8f0);
}

select:focus {
  outline: 2px solid var(--color-brand-500, #422AFB);
  outline-offset: 0;
  border-color: var(--color-brand-500, #422AFB);
}

input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):not([type="color"]),
textarea {
  background-color: var(--color-surface-primary, #ffffff);
  color: var(--color-text-primary, #1b2559);
}

input::placeholder,
textarea::placeholder {
  color: var(--color-text-secondary, #707eae);
  opacity: 0.7;
}

/* react-select dropdowns */
.react-select__control {
  background-color: var(--color-surface-primary, #ffffff) !important;
  border-color: var(--color-border-primary, #e2e8f0) !important;
  color: var(--color-text-primary, #1b2559) !important;
}

.react-select__single-value,
.react-select__input-container,
.react-select__input {
  color: var(--color-text-primary, #1b2559) !important;
}

.react-select__placeholder {
  color: var(--color-text-secondary, #707eae) !important;
}

.react-select__menu {
  background-color: var(--color-surface-primary, #ffffff) !important;
  color: var(--color-text-primary, #1b2559) !important;
  box-shadow: 0 4px 20px #7090b026 !important;
  border: 1px solid var(--color-border-primary, #e2e8f0) !important;
}

.react-select__option {
  background-color: var(--color-surface-primary, #ffffff) !important;
  color: var(--color-text-primary, #1b2559) !important;
}

.react-select__option--is-focused {
  background-color: var(--color-surface-secondary, #F4F7FE) !important;
  color: var(--color-text-primary, #1b2559) !important;
}

.react-select__option--is-selected {
  background-color: var(--color-brand-500, #422AFB) !important;
  color: #ffffff !important;
}

.react-select__indicator {
  color: var(--color-text-secondary, #707eae) !important;
}

.react-select__indicator-separator {
  background-color: var(--color-border-primary, #e2e8f0) !important;
}


input.defaultCheckbox::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: white;
  opacity: 0;
  height: 16px;
  width: 16px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0px);
}

input:checked.defaultCheckbox::before {
  opacity: 1;
}

.slidebar-scroller {
  direction: rtl;
}

.slidebar-scroller>* {
  direction: ltr;
}

/* Scrollbar width */
.slidebar-scroller::-webkit-scrollbar {
  width: 1px;
  background-color: transparent;
}

/* Scrollbar track (background) */
.slidebar-scroller::-webkit-scrollbar-track {
  background: transparent;
  /* track color */
  border-radius: 0px;
  /* rounded corners */
}

/* Scrollbar thumb (the draggable part) */
.slidebar-scroller::-webkit-scrollbar-thumb {
  background-color: var(--color-brand-500, #4318FF);
  /* thumb color */
  border-radius: 0px;
  /* creates padding effect */
}

/* Scrollbar thumb hover */
.slidebar-scroller::-webkit-scrollbar-thumb:hover {
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 80%, transparent);
}

/* ─── Global scrollbar styling ─────────────────────────────────────────────── */
/* Applies to the main window (html/body) and all scroll containers */

/* Width */
html::-webkit-scrollbar,
body::-webkit-scrollbar,
* ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track,
* ::-webkit-scrollbar-track {
  background: var(--color-scrollbar-track, #F4F7FE);
  border-radius: 10px;
}

/* Thumb */
html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb,
* ::-webkit-scrollbar-thumb {
  background-color: var(--color-scrollbar-thumb, #a3aed0);
  border-radius: 10px;
  border: 2px solid var(--color-scrollbar-track, #F4F7FE);
}

/* Thumb hover */
html::-webkit-scrollbar-thumb:hover,
body::-webkit-scrollbar-thumb:hover,
* ::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-scrollbar-thumb-hover, #422AFB);
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--color-scrollbar-thumb, #a3aed0) var(--color-scrollbar-track, #F4F7FE);
}

/* Smooth theme transitions */
body,
div,
header,
nav,
aside,
main,
section,
footer,
button,
a,
span,
p,
h1,
h2,
h3,
h4,
h5,
h6,
input,
select,
textarea {
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

/* Premium micro-interactions: hover effects for themed/contained buttons */
button,
.MuiButton-root {
  transition: filter 0.15s ease-in-out, transform 0.1s ease-in-out, background-color 0.15s ease-in-out !important;
}

button:hover,
.MuiButton-root:hover {
  filter: brightness(0.94) contrast(1.05);
}

.dark button:hover,
.dark .MuiButton-root:hover {
  filter: brightness(1.08) contrast(1.05);
}

/* Secondary action buttons need light labels on dark surfaces. */
.dark button.bg-surfaceSecondary,
.dark button.bg-lightPrimary {
  color: var(--color-text-primary, #f8fafc) !important;
}

.dark button.bg-surfaceSecondary svg,
.dark button.bg-lightPrimary svg {
  color: var(--color-text-primary, #f8fafc) !important;
}

button:active,
.MuiButton-root:active {
  transform: scale(0.98);
}

/* Style MUI DataGrid dropdowns, panels, columns, filters, density, and export menus */
.MuiPaper-root,
.MuiPopover-paper,
.MuiMenu-paper,
.MuiDataGrid-panel {
  background-color: var(--color-surface-primary, #ffffff) !important;
  color: var(--color-text-primary, #1b2559) !important;
  box-shadow: 0px 4px 20px var(--color-shadow-secondary, rgba(112, 144, 176, 0.15)) !important;
  border: 1px solid var(--color-shadow-secondary, rgba(112, 144, 176, 0.1)) !important;
}

/* List items / Menu options */
.MuiMenuItem-root,
.MuiListItem-root,
.MuiListItemText-root,
.MuiButtonBase-root.MuiMenuItem-root {
  color: var(--color-text-primary, #1b2559) !important;
}

.MuiMenuItem-root:hover,
.MuiListItemButton-root:hover {
  background-color: var(--color-surface-secondary, #F4F7FE) !important;
}

.MuiMenuItem-root.Mui-selected {
  background-color: var(--color-brand-50, #E9E3FF) !important;
  color: var(--color-brand-700, #422AFB) !important;
}

/* Input fields & Select elements inside filters */
.MuiPaper-root .MuiInputBase-root,
.MuiPaper-root .MuiInput-root,
.MuiPaper-root .MuiNativeSelect-select,
.MuiPaper-root .MuiSelect-select,
.MuiPaper-root .MuiInputBase-input {
  color: var(--color-text-primary, #1b2559) !important;
}

.MuiPaper-root .MuiInput-underline:before {
  border-bottom-color: var(--color-shadow-secondary, rgba(0, 0, 0, 0.12)) !important;
}

.MuiPaper-root .MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom-color: var(--color-text-secondary, #707eae) !important;
}

/* Labels */
.MuiPaper-root .MuiFormLabel-root,
.MuiPaper-root .MuiInputLabel-root {
  color: var(--color-text-secondary, #707eae) !important;
}

/* Icons inside popovers/menus */
.MuiPaper-root .MuiSvgIcon-root,
.MuiDataGrid-panel .MuiSvgIcon-root {
  color: var(--color-text-secondary, #707eae) !important;
}

/* Buttons inside popovers/menus (like Columns show/hide, Filters clear/add) */
.MuiPaper-root .MuiButton-root,
.MuiDataGrid-panel .MuiButton-root {
  color: var(--color-brand-500, #422AFB) !important;
}

.MuiPaper-root .MuiButton-root:hover,
.MuiDataGrid-panel .MuiButton-root:hover {
  background-color: var(--color-brand-50, #E9E3FF) !important;
}

.placeholder\\:\\!text-gray-400::placeholder{
  --tw-text-opacity: 1 !important;
  color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-text-opacity, 1) * 100%), transparent) !important;
}

.placeholder\\:text-green-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-red-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(245 57 57 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-textMuted::placeholder{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-muted, #a3aed0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.placeholder\\:text-textSecondary::placeholder{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #707eae) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}

.before\\:left-\\[50\\%\\]::before{
  content: var(--tw-content);
  left: 50%;
}

.before\\:top-\\[3px\\]::before{
  content: var(--tw-content);
  top: 3px;
}

.before\\:top-\\[50\\%\\]::before{
  content: var(--tw-content);
  top: 50%;
}

.before\\:h-3::before{
  content: var(--tw-content);
  height: 0.75rem;
}

.before\\:h-4::before{
  content: var(--tw-content);
  height: 1rem;
}

.before\\:w-3::before{
  content: var(--tw-content);
  width: 0.75rem;
}

.before\\:w-4::before{
  content: var(--tw-content);
  width: 1rem;
}

.before\\:translate-x-\\[-50\\%\\]::before{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:translate-x-\\[2px\\]::before{
  content: var(--tw-content);
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:translate-y-\\[-50\\%\\]::before{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:rounded-\\[20px\\]::before{
  content: var(--tw-content);
  border-radius: 20px;
}

.before\\:rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-white::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.before\\:shadow-\\[0_2px_5px_rgba\\(0\\2c _0\\2c _0\\2c _\\.2\\)\\]::before{
  content: var(--tw-content);
  --tw-shadow: 0 2px 5px rgba(0, 0, 0, .2);
  --tw-shadow-colored: 0 2px 5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.before\\:transition::before{
  content: var(--tw-content);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:transition-all::before{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:duration-\\[0\\.2s\\]::before{
  content: var(--tw-content);
  transition-duration: 0.2s;
}

.before\\:content-\\[\\"\\"\\]::before{
  --tw-content: "";
  content: var(--tw-content);
}

.checked\\:border-none:checked{
  border-style: none;
}

.checked\\:\\!border-amber-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-blue-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-brand-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}

.checked\\:\\!border-cyan-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(23 193 232 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-gray-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-text-secondary, #adb5bd) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}

.checked\\:\\!border-green-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-indigo-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-lime-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(130 214 22 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-navy-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-navy-500, #1b3bbb) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}

.checked\\:\\!border-orange-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(249 115 22 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-pink-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 0 128 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-purple-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-red-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(245 57 57 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-teal-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(20 184 166 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:\\!border-yellow-500:checked{
  --tw-border-opacity: 1 !important;
  border-color: rgb(234 179 8 / var(--tw-border-opacity, 1)) !important;
}

.checked\\:bg-amber-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-blue-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-brand-500:checked{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.checked\\:bg-cyan-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(23 193 232 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-gray-500:checked{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-text-secondary, #adb5bd) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.checked\\:bg-green-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-indigo-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-lime-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(130 214 22 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-navy-500:checked{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-navy-500, #1b3bbb) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.checked\\:bg-orange-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-pink-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 128 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-purple-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-red-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(245 57 57 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-teal-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}

.checked\\:bg-yellow-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}

.checked\\:text-white:checked{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.checked\\:before\\:translate-x-\\[22px\\]:checked::before{
  content: var(--tw-content);
  --tw-translate-x: 22px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.checked\\:before\\:\\!bg-amber-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-blue-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-brand-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.checked\\:before\\:\\!bg-cyan-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(23 193 232 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-gray-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-text-secondary, #adb5bd) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.checked\\:before\\:\\!bg-green-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-indigo-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-lime-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(130 214 22 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-navy-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-navy-500, #1b3bbb) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.checked\\:before\\:\\!bg-orange-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-pink-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 0 128 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-purple-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-red-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 57 57 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-teal-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1)) !important;
}

.checked\\:before\\:\\!bg-yellow-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1)) !important;
}

.focus-within\\:border-brand-400:focus-within{
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-brand-400, #7551FF) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}

.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:cursor-pointer:hover{
  cursor: pointer;
}

.hover\\:border-brand-500:hover{
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}

.hover\\:border-brand-500\\/80:hover{
  border-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 80%, transparent);
}

.hover\\:\\!bg-copyBtnSurface\\/80:hover{
  background-color: color-mix(in srgb, var(--color-copy-btn-surface, #16A34A) 80%, transparent) !important;
}

.hover\\:\\!bg-white\\/80:hover{
  background-color: rgb(255 255 255 / 0.8) !important;
}

.hover\\:bg-\\[\\#e2e8f0\\]\\/80:hover{
  background-color: rgb(226 232 240 / 0.8);
}

.hover\\:bg-brand-50:hover{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-50, #E9E3FF) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.hover\\:bg-brand-50\\/80:hover{
  background-color: color-mix(in srgb, var(--color-brand-50, #E9E3FF) 80%, transparent);
}

.hover\\:bg-brand-500\\/10:hover{
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 10%, transparent);
}

.hover\\:bg-brand-500\\/80:hover{
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 80%, transparent);
}

.hover\\:bg-brand-900\\/80:hover{
  background-color: color-mix(in srgb, var(--color-brand-900, #11047A) 80%, transparent);
}

.hover\\:bg-copyBtnSurface\\/80:hover{
  background-color: color-mix(in srgb, var(--color-copy-btn-surface, #16A34A) 80%, transparent);
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-surface-secondary, #f8f9fa) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700\\/80:hover{
  background-color: rgb(21 128 61 / 0.8);
}

.hover\\:bg-lightPrimary\\/80:hover{
  background-color: color-mix(in srgb, var(--color-light-primary, #F4F7FE) 80%, transparent);
}

.hover\\:bg-red-500\\/10:hover{
  background-color: rgb(245 57 57 / 0.1);
}

.hover\\:bg-red-500\\/20:hover{
  background-color: rgb(245 57 57 / 0.2);
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-surfacePrimary\\/80:hover{
  background-color: color-mix(in srgb, var(--color-surface-primary, #ffffff) 80%, transparent);
}

.hover\\:bg-surfaceSecondary\\/80:hover{
  background-color: color-mix(in srgb, var(--color-surface-secondary, #F4F7FE) 80%, transparent);
}

.hover\\:bg-gradient-to-b:hover{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.hover\\:bg-none:hover{
  background-image: none;
}

.hover\\:from-white\\/40:hover{
  --tw-gradient-from: rgb(255 255 255 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-white\\/5:hover{
  --tw-gradient-to: rgb(255 255 255 / 0.05) var(--tw-gradient-to-position);
}

.hover\\:font-medium:hover{
  font-weight: 500;
}

.hover\\:text-\\[\\#ff0000\\]\\/80:hover{
  color: rgb(255 0 0 / 0.8);
}

.hover\\:text-brand-500:hover{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.hover\\:text-brand-500\\/80:hover{
  color: color-mix(in srgb, var(--color-brand-500, #422AFB) 80%, transparent);
}

.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #a3aed0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #707eae) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.hover\\:text-lightPrimary:hover{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-light-primary, #F4F7FE) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.hover\\:text-navy-700:hover{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-primary, #1B254B) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(245 57 57 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(234 6 6 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600\\/80:hover{
  color: rgb(234 6 6 / 0.8);
}

.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-textPrimary:hover{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-primary, #1b2559) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:no-underline:hover{
  text-decoration-line: none;
}

.hover\\:shadow-2xl:hover{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:cursor-pointer:focus{
  cursor: pointer;
}

.focus\\:border-\\[\\#422AFB\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(66 42 251 / var(--tw-border-opacity, 1));
}

.focus\\:border-brand-500:focus{
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}

.focus\\:bg-surfaceSecondary:focus{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-surface-secondary, #F4F7FE) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.focus\\:text-textPrimary:focus{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-primary, #1b2559) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.focus\\:no-underline:focus{
  text-decoration-line: none;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[\\#422AFB\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(66 42 251 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-brand-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: color-mix(in srgb, var(--color-brand-200, #A195FD) calc(var(--tw-ring-opacity, 1) * 100%), transparent);
}

.focus\\:ring-brand-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-ring-opacity, 1) * 100%), transparent);
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-brand-300:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: color-mix(in srgb, var(--color-brand-300, #8171FC) calc(var(--tw-ring-opacity, 1) * 100%), transparent);
}

.focus-visible\\:ring-indigo-300:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity, 1));
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:\\!bg-copyBtnSurface\\/70:active{
  background-color: color-mix(in srgb, var(--color-copy-btn-surface, #16A34A) 70%, transparent) !important;
}

.active\\:\\!bg-white\\/70:active{
  background-color: rgb(255 255 255 / 0.7) !important;
}

.active\\:bg-\\[\\#e2e8f0\\]\\/70:active{
  background-color: rgb(226 232 240 / 0.7);
}

.active\\:bg-brand-50\\/70:active{
  background-color: color-mix(in srgb, var(--color-brand-50, #E9E3FF) 70%, transparent);
}

.active\\:bg-brand-500\\/70:active{
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 70%, transparent);
}

.active\\:bg-brand-900\\/70:active{
  background-color: color-mix(in srgb, var(--color-brand-900, #11047A) 70%, transparent);
}

.active\\:bg-copyBtnSurface\\/70:active{
  background-color: color-mix(in srgb, var(--color-copy-btn-surface, #16A34A) 70%, transparent);
}

.active\\:bg-green-700\\/70:active{
  background-color: rgb(21 128 61 / 0.7);
}

.active\\:bg-lightPrimary\\/70:active{
  background-color: color-mix(in srgb, var(--color-light-primary, #F4F7FE) 70%, transparent);
}

.active\\:bg-red-500\\/20:active{
  background-color: rgb(245 57 57 / 0.2);
}

.active\\:bg-red-500\\/30:active{
  background-color: rgb(245 57 57 / 0.3);
}

.active\\:bg-red-800:active{
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}

.active\\:bg-surfacePrimary\\/70:active{
  background-color: color-mix(in srgb, var(--color-surface-primary, #ffffff) 70%, transparent);
}

.active\\:bg-surfaceSecondary\\/70:active{
  background-color: color-mix(in srgb, var(--color-surface-secondary, #F4F7FE) 70%, transparent);
}

.active\\:bg-none:active{
  background-image: none;
}

.active\\:text-\\[\\#ff0000\\]\\/70:active{
  color: rgb(255 0 0 / 0.7);
}

.active\\:text-brand-500\\/70:active{
  color: color-mix(in srgb, var(--color-brand-500, #422AFB) 70%, transparent);
}

.active\\:text-red-600\\/70:active{
  color: rgb(234 6 6 / 0.7);
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:bg-gray-300:disabled{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.disabled\\:text-\\[\\#00000067\\]:disabled{
  color: #00000067;
}

.disabled\\:text-gray-400:disabled{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:hover\\:cursor-not-allowed:hover:disabled{
  cursor: not-allowed;
}

.disabled\\:hover\\:bg-brand-500:hover:disabled{
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.dark\\:\\!border-gray-800:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-text-primary, #252f40) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}

.dark\\:\\!border-green-400:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:\\!border-navy-700:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-text-primary, #1B254B) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}

.dark\\:\\!border-navy-800:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-surface-primary, #111c44) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}

.dark\\:\\!border-red-400:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:\\!border-white\\/10:is(.dark *){
  border-color: rgb(255 255 255 / 0.1) !important;
}

.dark\\:border-navy-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-navy-500, #1b3bbb) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}

.dark\\:border-navy-600:is(.dark *){
  --tw-border-opacity: 1;
  border-color: color-mix(in srgb, var(--color-navy-600, #24388a) calc(var(--tw-border-opacity, 1) * 100%), transparent);
}

.dark\\:border-red-900\\/50:is(.dark *){
  border-color: rgb(127 29 29 / 0.5);
}

.dark\\:border-white\\/10:is(.dark *){
  border-color: rgb(255 255 255 / 0.1);
}

.dark\\:\\!bg-navy-700:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-text-primary, #1B254B) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.dark\\:\\!bg-navy-800:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-surface-primary, #111c44) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.dark\\:\\!bg-navy-900:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-light-primary, #0b1437) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.dark\\:\\!bg-white:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:\\!bg-white\\/5:is(.dark *){
  background-color: rgb(255 255 255 / 0.05) !important;
}

.dark\\:bg-\\[\\#0b14374d\\]:is(.dark *){
  background-color: #0b14374d;
}

.dark\\:bg-\\[\\#e2e8f0\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-amber-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-brand-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-400, #7551FF) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:bg-brand-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:bg-cyan-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(33 212 253 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:bg-gray-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-text-primary, #252f40) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:bg-green-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-100:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lime-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(152 236 45 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-navy-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-navy-400, #3652ba) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:bg-navy-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-navy-600, #24388a) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:bg-navy-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-text-primary, #1B254B) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:bg-navy-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-surface-primary, #111c44) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:bg-navy-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-light-primary, #0b1437) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:bg-orange-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-pink-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-teal-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-white\\/10:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:bg-white\\/20:is(.dark *){
  background-color: rgb(255 255 255 / 0.2);
}

.dark\\:bg-white\\/30:is(.dark *){
  background-color: rgb(255 255 255 / 0.3);
}

.dark\\:bg-white\\/5:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:bg-yellow-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 51 / var(--tw-bg-opacity, 1));
}

.dark\\:\\!text-green-400:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:\\!text-red-400:is(.dark *){
  --tw-text-opacity: 1 !important;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:text-\\[\\#1b2559\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(27 37 89 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-brand-100:is(.dark *){
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-brand-100, #C0B8FE) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.dark\\:text-brand-300:is(.dark *){
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-brand-300, #8171FC) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.dark\\:text-gray-300:is(.dark *){
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.dark\\:text-gray-400:is(.dark *){
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.dark\\:text-gray-500:is(.dark *){
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #adb5bd) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.dark\\:text-green-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}

.dark\\:text-navy-900:is(.dark *){
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-light-primary, #0b1437) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.dark\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:shadow-none:is(.dark *){
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:placeholder\\:\\!text-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.15\\)\\]:is(.dark *)::placeholder{
  color: rgba(255,255,255,0.15) !important;
}

.dark\\:placeholder\\:\\!text-green-400:is(.dark *)::placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:placeholder\\:\\!text-red-400:is(.dark *)::placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:placeholder\\:\\!text-white:is(.dark *)::placeholder{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:placeholder\\:text-gray-400:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.dark\\:checked\\:\\!border-amber-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-blue-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-brand-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-brand-400, #7551FF) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}

.dark\\:checked\\:\\!border-cyan-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 212 253 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-gray-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}

.dark\\:checked\\:\\!border-green-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-indigo-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-lime-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(152 236 45 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-navy-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: color-mix(in srgb, var(--color-navy-400, #3652ba) calc(var(--tw-border-opacity, 1) * 100%), transparent) !important;
}

.dark\\:checked\\:\\!border-orange-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(251 146 60 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-pink-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 114 182 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-purple-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-red-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-teal-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(45 212 191 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:\\!border-yellow-400:checked:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(251 207 51 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:checked\\:bg-amber-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-blue-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-brand-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-brand-400, #7551FF) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:checked\\:bg-cyan-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(33 212 253 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-gray-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:checked\\:bg-green-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-indigo-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-lime-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(152 236 45 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-navy-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-navy-400, #3652ba) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:checked\\:bg-orange-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-pink-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-purple-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-red-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-teal-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:bg-yellow-400:checked:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 51 / var(--tw-bg-opacity, 1));
}

.dark\\:checked\\:before\\:\\!bg-amber-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-blue-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-brand-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-brand-400, #7551FF) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.dark\\:checked\\:before\\:\\!bg-cyan-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(33 212 253 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-gray-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-text-secondary, #a0aec0) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.dark\\:checked\\:before\\:\\!bg-green-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-indigo-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-lime-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(152 236 45 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-navy-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-navy-400, #3652ba) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.dark\\:checked\\:before\\:\\!bg-orange-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-pink-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-purple-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-red-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-teal-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:checked\\:before\\:\\!bg-yellow-400:checked:is(.dark *)::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1 !important;
  background-color: rgb(251 207 51 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:hover\\:\\!bg-navy-700:hover:is(.dark *){
  --tw-bg-opacity: 1 !important;
  background-color: color-mix(in srgb, var(--color-text-primary, #1B254B) calc(var(--tw-bg-opacity, 1) * 100%), transparent) !important;
}

.dark\\:hover\\:bg-\\[\\#e2e8f0\\]\\/80:hover:is(.dark *){
  background-color: rgb(226 232 240 / 0.8);
}

.dark\\:hover\\:bg-brand-400\\/80:hover:is(.dark *){
  background-color: color-mix(in srgb, var(--color-brand-400, #7551FF) 80%, transparent);
}

.dark\\:hover\\:bg-brand-500\\/80:hover:is(.dark *){
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 80%, transparent);
}

.dark\\:hover\\:bg-navy-600:hover:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: color-mix(in srgb, var(--color-navy-600, #24388a) calc(var(--tw-bg-opacity, 1) * 100%), transparent);
}

.dark\\:hover\\:bg-navy-700\\/80:hover:is(.dark *){
  background-color: color-mix(in srgb, var(--color-text-primary, #1B254B) 80%, transparent);
}

.dark\\:hover\\:bg-white\\/10:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:bg-white\\/20:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.2);
}

.dark\\:hover\\:text-gray-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: color-mix(in srgb, var(--color-border-primary, #cbd5e0) calc(var(--tw-text-opacity, 1) * 100%), transparent);
}

.dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:dark\\:text-white:is(.dark *):hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:focus\\:ring-brand-900:focus:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: color-mix(in srgb, var(--color-brand-900, #11047A) calc(var(--tw-ring-opacity, 1) * 100%), transparent);
}

.dark\\:active\\:bg-\\[\\#e2e8f0\\]\\/70:active:is(.dark *){
  background-color: rgb(226 232 240 / 0.7);
}

.dark\\:active\\:bg-brand-400\\/70:active:is(.dark *){
  background-color: color-mix(in srgb, var(--color-brand-400, #7551FF) 70%, transparent);
}

.dark\\:active\\:bg-brand-500\\/70:active:is(.dark *){
  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 70%, transparent);
}

.dark\\:active\\:bg-navy-700\\/70:active:is(.dark *){
  background-color: color-mix(in srgb, var(--color-text-primary, #1B254B) 70%, transparent);
}

.dark\\:active\\:bg-white\\/10:active:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:active\\:bg-white\\/20:active:is(.dark *){
  background-color: rgb(255 255 255 / 0.2);
}

@media (min-width: 576px){
  .sm\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .sm\\:\\!mb-0{
    margin-bottom: 0px !important;
  }
  .sm\\:ml-4{
    margin-left: 1rem;
  }
  .sm\\:mt-0{
    margin-top: 0px;
  }
  .sm\\:mt-16{
    margin-top: 4rem;
  }
  .sm\\:flex{
    display: flex;
  }
  .sm\\:w-2\\/3{
    width: 66.666667%;
  }
  .sm\\:w-\\[100\\%\\]{
    width: 100%;
  }
  .sm\\:w-\\[25\\%\\]{
    width: 25%;
  }
  .sm\\:w-\\[460px\\]{
    width: 460px;
  }
  .sm\\:w-\\[69\\%\\]{
    width: 69%;
  }
  .sm\\:w-\\[70\\%\\]{
    width: 70%;
  }
  .sm\\:w-\\[75\\%\\]{
    width: 75%;
  }
  .sm\\:w-fit{
    width: fit-content;
  }
  .sm\\:w-full{
    width: 100%;
  }
  .sm\\:max-w-3xl{
    max-width: 48rem;
  }
  .sm\\:translate-y-0{
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .sm\\:scale-100{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .sm\\:scale-95{
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:flex-row-reverse{
    flex-direction: row-reverse;
  }
  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }
  .sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }
  .sm\\:items-start{
    align-items: flex-start;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:justify-start{
    justify-content: flex-start;
  }
  .sm\\:overflow-auto{
    overflow: auto;
  }
  .sm\\:overflow-x-auto{
    overflow-x: auto;
  }
  .sm\\:p-0{
    padding: 0px;
  }
  .sm\\:p-6{
    padding: 1.5rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:pb-4{
    padding-bottom: 1rem;
  }
  .sm\\:pt-16{
    padding-top: 4rem;
  }
  .sm\\:text-left{
    text-align: left;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 768px){
  .md\\:-left-\\[330px\\]{
    left: -330px;
  }
  .md\\:-left-\\[440px\\]{
    left: -440px;
  }
  .md\\:-start-\\[330px\\]{
    inset-inline-start: -330px;
  }
  .md\\:-start-\\[440px\\]{
    inset-inline-start: -440px;
  }
  .md\\:\\!z-50{
    z-index: 50 !important;
  }
  .md\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .md\\:mt-16{
    margin-top: 4rem;
  }
  .md\\:mt-2{
    margin-top: 0.5rem;
  }
  .md\\:w-72{
    width: 18rem;
  }
  .md\\:w-\\[100\\%\\]{
    width: 100%;
  }
  .md\\:w-\\[365px\\]{
    width: 365px;
  }
  .md\\:w-\\[64\\%\\]{
    width: 64%;
  }
  .md\\:flex-grow-0{
    flex-grow: 0;
  }
  .md\\:origin-top-right{
    transform-origin: top right;
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:flex-col{
    flex-direction: column;
  }
  .md\\:items-start{
    align-items: flex-start;
  }
  .md\\:items-center{
    align-items: center;
  }
  .md\\:\\!gap-14{
    gap: 3.5rem !important;
  }
  .md\\:gap-1{
    gap: 0.25rem;
  }
  .md\\:gap-10{
    gap: 2.5rem;
  }
  .md\\:\\!px-0{
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .md\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }
  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .md\\:px-\\[64px\\]{
    padding-left: 64px;
    padding-right: 64px;
  }
  .md\\:py-\\[56px\\]{
    padding-top: 56px;
    padding-bottom: 56px;
  }
  .md\\:pe-2{
    padding-inline-end: 0.5rem;
  }
  .md\\:pl-8{
    padding-left: 2rem;
  }
  .md\\:pr-2{
    padding-right: 0.5rem;
  }
  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:leading-\\[42px\\]{
    line-height: 42px;
  }
  .md\\:pe-2{
    padding-inline-end: 0.5rem;
  }
  [dir="ltr"] .md\\:origin-top-start{
    transform-origin: top left;
  }
  [dir="rtl"] .md\\:origin-top-start{
    transform-origin: top right;
  }
}

@media (min-width: 992px){
  .lg\\:\\!z-50{
    z-index: 50 !important;
  }
  .lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }
  .lg\\:mb-0{
    margin-bottom: 0px;
  }
  .lg\\:mb-16{
    margin-bottom: 4rem;
  }
  .lg\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .lg\\:mt-0{
    margin-top: 0px;
  }
  .lg\\:block{
    display: block;
  }
  .lg\\:w-\\[40\\%\\]{
    width: 40%;
  }
  .lg\\:w-\\[46\\%\\]{
    width: 46%;
  }
  .lg\\:max-w-\\[100\\%\\]{
    max-width: 100%;
  }
  .lg\\:max-w-\\[65\\%\\]{
    max-width: 65%;
  }
  .lg\\:max-w-none{
    max-width: none;
  }
  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:flex-nowrap{
    flex-wrap: nowrap;
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:justify-between{
    justify-content: space-between;
  }
  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .lg\\:pb-0{
    padding-bottom: 0px;
  }
  .lg\\:text-white{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
  .lg\\:hover\\:text-white:hover{
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}

@media (min-width: 1200px){
  .xl\\:\\!z-0{
    z-index: 0 !important;
  }
  .xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }
  .xl\\:mb-2{
    margin-bottom: 0.5rem;
  }
  .xl\\:ml-\\[313px\\]{
    margin-left: 313px;
  }
  .xl\\:ml-\\[80px\\]{
    margin-left: 80px;
  }
  .xl\\:mr-\\[313px\\]{
    margin-right: 313px;
  }
  .xl\\:block{
    display: block;
  }
  .xl\\:flex{
    display: flex;
  }
  .xl\\:hidden{
    display: none;
  }
  .xl\\:h-\\[350px\\]{
    height: 350px;
  }
  .xl\\:w-\\[1310px\\]{
    width: 1310px;
  }
  .xl\\:w-\\[225px\\]{
    width: 225px;
  }
  .xl\\:w-\\[365px\\]{
    width: 365px;
  }
  .xl\\:w-\\[72\\%\\]{
    width: 72%;
  }
  .xl\\:w-\\[80px\\]{
    width: 80px;
  }
  .xl\\:w-\\[85\\%\\]{
    width: 85%;
  }
  .xl\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:flex-row{
    flex-direction: row;
  }
  .xl\\:flex-col{
    flex-direction: column;
  }
  .xl\\:items-start{
    align-items: flex-start;
  }
  .xl\\:gap-2{
    gap: 0.5rem;
  }
  .xl\\:overflow-x-hidden{
    overflow-x: hidden;
  }
  .xl\\:\\!px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
  .xl\\:pb-6{
    padding-bottom: 1.5rem;
  }
  .xl\\:text-\\[16px\\]{
    font-size: 16px;
  }
}

@media (min-width: 1320px){
  .\\32xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }
  .\\32xl\\:col-span-6{
    grid-column: span 6 / span 6;
  }
  .\\32xl\\:ml-2{
    margin-left: 0.5rem;
  }
  .\\32xl\\:w-\\[60\\%\\]{
    width: 60%;
  }
  .\\32xl\\:w-\\[75\\%\\]{
    width: 75%;
  }
  .\\32xl\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }
  .\\32xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .\\32xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .\\32xl\\:items-start{
    align-items: flex-start;
  }
  .\\32xl\\:gap-10{
    gap: 2.5rem;
  }
  .\\32xl\\:overflow-hidden{
    overflow: hidden;
  }
}

@media (min-width: 1600px){
  .\\33xl\\:h-full{
    height: 100%;
  }
  .\\33xl\\:w-\\[45\\%\\]{
    width: 45%;
  }
  .\\33xl\\:w-\\[52\\%\\]{
    width: 52%;
  }
  .\\33xl\\:w-full{
    width: 100%;
  }
  .\\33xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .\\33xl\\:flex-row{
    flex-direction: row;
  }
  .\\33xl\\:items-center{
    align-items: center;
  }
  .\\33xl\\:justify-between{
    justify-content: space-between;
  }
}

.rtl\\:text-right:where([dir="rtl"], [dir="rtl"] *){
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,kDAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,2CAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;IAAA,6CAAc;IAAd,wCAAc;IAAd,mCAAc;IAAd,sBAAc;EAAA;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,uHAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mKAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,gDAAgD;EAChD,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;;EAElC,eAAe;EACf,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;;EAE3B,uBAAuB;EACvB,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;;EAE/B,YAAY;EACZ,+BAA+B;EAC/B,iCAAiC;;EAEjC,4DAA4D;EAC5D,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,eAAe;EACf,gCAAgC;EAChC,gCAAgC;AAClC;;AAWA,iFAAiF;AACjF,gFAAgF;;AAEhF;;EAEE,uDAAuD;EACvD,yCAAyC;EACzC,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;EAClD,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;;EAEE,uDAAuD;EACvD,yCAAyC;AAC3C;;AAEA;;EAEE,2CAA2C;EAC3C,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,kEAAkE;EAClE,6DAA6D;EAC7D,oDAAoD;AACtD;;AAEA;;;EAGE,oDAAoD;AACtD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kEAAkE;EAClE,oDAAoD;EACpD,2CAA2C;EAC3C,iEAAiE;AACnE;;AAEA;EACE,kEAAkE;EAClE,oDAAoD;AACtD;;AAEA;EACE,oEAAoE;EACpE,oDAAoD;AACtD;;AAEA;EACE,4DAA4D;EAC5D,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,iEAAiE;AACnE;;;AAGA;EACE,gDAA2C;EAC3C,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,sFAAsF;AACxF;;AAEA,iFAAiF;AACjF,qEAAqE;;AAErE,UAAU;AACV;;;EAGE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;;;EAGE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA,UAAU;AACV;;;EAGE,uDAAuD;EACvD,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA,gBAAgB;AAChB;;;EAGE,6DAA6D;AAC/D;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,4FAA4F;AAC9F;;AAEA,6BAA6B;AAC7B;;;;;;;;;;;;;;;;;;;;;EAqBE,qGAAqG;AACvG;;AAEA,2EAA2E;AAC3E;;EAEE,+GAA+G;AACjH;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA,iEAAiE;AACjE;;EAEE,oDAAoD;AACtD;;AAEA;;EAEE,oDAAoD;AACtD;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,sFAAsF;AACtF;;;;EAIE,kEAAkE;EAClE,oDAAoD;EACpD,4FAA4F;EAC5F,oFAAoF;AACtF;;AAEA,8BAA8B;AAC9B;;;;EAIE,oDAAoD;AACtD;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;EACE,2DAA2D;EAC3D,iDAAiD;AACnD;;AAEA,kDAAkD;AAClD;;;;;EAKE,oDAAoD;AACtD;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,oEAAoE;AACtE;;AAEA,WAAW;AACX;;EAEE,sDAAsD;AACxD;;AAEA,gCAAgC;AAChC;;EAEE,sDAAsD;AACxD;;AAEA,8EAA8E;AAC9E;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,2DAA2D;AAC7D;;AAjWA;EAAA,+BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,sBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,qBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,sBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,wCAiWC;EAjWD,qDAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,wJAiWC;EAjWD,wDAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,wBAiWC;EAjWD,wDAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,gBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,sBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,sBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,2GAiWC;EAjWD,yGAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,sBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,2EAiWC;EAjWD,qEAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,gDAiWC;EAjWD,6DAiWC;EAjWD;AAiWC;;AAjWD;EAAA,+EAiWC;EAjWD,mGAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,sBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,sBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,8BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,2GAiWC;EAjWD,yGAiWC;EAjWD;AAiWC;;AAjWD;EAAA,2GAiWC;EAjWD,yGAiWC;EAjWD;AAiWC;;AAjWD;EAAA,2GAiWC;EAjWD,yGAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,8BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,2GAiWC;EAjWD,yGAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iBAiWC;EAjWD,iBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,sBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,sBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,+BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,+BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,sBAiWC;EAjWD,8BAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,+BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,+BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,+BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,iCAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,0BAiWC;EAjWD,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA,6BAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,kBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA,oBAiWC;EAjWD;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;AAiWC;;AAjWD;EAAA;IAAA,gBAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,qBAiWC;IAjWD;EAiWC;EAjWD;IAAA,eAiWC;IAjWD,eAiWC;IAjWD;EAiWC;EAjWD;IAAA,iBAiWC;IAjWD,iBAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,oBAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,mBAiWC;IAjWD;EAiWC;AAAA;;AAjWD;EAAA;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,gBAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,4BAiWC;IAjWD;EAiWC;EAjWD;IAAA,iBAiWC;IAjWD;EAiWC;EAjWD;IAAA,oBAiWC;IAjWD;EAiWC;EAjWD;IAAA,kBAiWC;IAjWD;EAiWC;EAjWD;IAAA,iBAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,mBAiWC;IAjWD;EAiWC;EAjWD;IAAA,eAiWC;IAjWD;EAiWC;EAjWD;IAAA,mBAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;AAAA;;AAjWD;EAAA;IAAA;EAiWC;EAjWD;IAAA,gBAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,kBAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,oBAiWC;IAjWD;EAiWC;EAjWD;IAAA,oBAiWC;IAjWD;EAiWC;AAAA;;AAjWD;EAAA;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,qBAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA,6BAiWC;IAjWD;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;AAAA;;AAjWD;EAAA;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;AAAA;;AAjWD;EAAA;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;EAjWD;IAAA;EAiWC;AAAA;;AAjWD;EAAA;AAiWC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  /* Default Horizon UI Purple/Blue Theme Colors */\n  --color-light-primary: #F4F7FE;\n  --color-blue-secondary: #4318FF;\n  --color-brand-linear: #868CFF;\n  --color-brand-50: #E9E3FF;\n  --color-brand-100: #C0B8FE;\n  --color-brand-200: #A195FD;\n  --color-brand-300: #8171FC;\n  --color-brand-400: #7551FF;\n  --color-brand-500: #422AFB;\n  --color-brand-700: #2111A5;\n  --color-brand-900: #11047A;\n\n  /* Button Surfaces and Icons */\n  --color-copy-btn-surface: #16A34A;\n  --color-copy-btn-icon: #ffffff;\n  --color-download-btn-surface: #6495ED;\n  --color-download-btn-icon: #ffffff;\n\n  /* Typography */\n  --color-text-primary: #1b2559;\n  --color-text-secondary: #707eae;\n  --color-text-muted: #a3aed0;\n\n  /* Surfaces & Borders */\n  --color-surface-primary: #ffffff;\n  --color-surface-secondary: #F4F7FE;\n  --color-border-primary: #e2e8f0;\n\n  /* Shadows */\n  --color-shadow-primary: #7090b0;\n  --color-shadow-secondary: #7090b0;\n\n  /* Navy palette (used by dark: variants, themed per-theme) */\n  --color-navy-400: #3652ba;\n  --color-navy-500: #1b3bbb;\n  --color-navy-600: #24388a;\n  --color-navy-700: #1B254B;\n  --color-navy-800: #111c44;\n  --color-navy-900: #0b1437;\n\n  /* Scrollbars */\n  --color-scrollbar-thumb: #a3aed0;\n  --color-scrollbar-track: #F4F7FE;\n}\n\n@layer base {\n  html {\n    font-family: 'Poppins', sans-serif !important;\n    font-feature-settings: 'kern' !important;\n    -webkit-font-smoothing: antialiased;\n    letter-spacing: -0.5px;\n  }\n}\n\n/* ─── Native form element theming ──────────────────────────────────────────── */\n/* Ensures all native <select>, <option>, <input>, <textarea> follow the theme */\n\nselect,\nselect option {\n  background-color: var(--color-surface-primary, #ffffff);\n  color: var(--color-text-primary, #1b2559);\n  border-color: var(--color-border-primary, #e2e8f0);\n}\n\nselect:focus {\n  outline: 2px solid var(--color-brand-500, #422AFB);\n  outline-offset: 0;\n  border-color: var(--color-brand-500, #422AFB);\n}\n\ninput:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]):not([type=\"color\"]),\ntextarea {\n  background-color: var(--color-surface-primary, #ffffff);\n  color: var(--color-text-primary, #1b2559);\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  color: var(--color-text-secondary, #707eae);\n  opacity: 0.7;\n}\n\n/* react-select dropdowns */\n.react-select__control {\n  background-color: var(--color-surface-primary, #ffffff) !important;\n  border-color: var(--color-border-primary, #e2e8f0) !important;\n  color: var(--color-text-primary, #1b2559) !important;\n}\n\n.react-select__single-value,\n.react-select__input-container,\n.react-select__input {\n  color: var(--color-text-primary, #1b2559) !important;\n}\n\n.react-select__placeholder {\n  color: var(--color-text-secondary, #707eae) !important;\n}\n\n.react-select__menu {\n  background-color: var(--color-surface-primary, #ffffff) !important;\n  color: var(--color-text-primary, #1b2559) !important;\n  box-shadow: 0 4px 20px #7090b026 !important;\n  border: 1px solid var(--color-border-primary, #e2e8f0) !important;\n}\n\n.react-select__option {\n  background-color: var(--color-surface-primary, #ffffff) !important;\n  color: var(--color-text-primary, #1b2559) !important;\n}\n\n.react-select__option--is-focused {\n  background-color: var(--color-surface-secondary, #F4F7FE) !important;\n  color: var(--color-text-primary, #1b2559) !important;\n}\n\n.react-select__option--is-selected {\n  background-color: var(--color-brand-500, #422AFB) !important;\n  color: #ffffff !important;\n}\n\n.react-select__indicator {\n  color: var(--color-text-secondary, #707eae) !important;\n}\n\n.react-select__indicator-separator {\n  background-color: var(--color-border-primary, #e2e8f0) !important;\n}\n\n\ninput.defaultCheckbox::before {\n  content: url(../src/assets/svg/checked.svg);\n  color: white;\n  opacity: 0;\n  height: 16px;\n  width: 16px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0px);\n}\n\ninput:checked.defaultCheckbox::before {\n  opacity: 1;\n}\n\n.slidebar-scroller {\n  direction: rtl;\n}\n\n.slidebar-scroller>* {\n  direction: ltr;\n}\n\n/* Scrollbar width */\n.slidebar-scroller::-webkit-scrollbar {\n  width: 1px;\n  background-color: transparent;\n}\n\n/* Scrollbar track (background) */\n.slidebar-scroller::-webkit-scrollbar-track {\n  background: transparent;\n  /* track color */\n  border-radius: 0px;\n  /* rounded corners */\n}\n\n/* Scrollbar thumb (the draggable part) */\n.slidebar-scroller::-webkit-scrollbar-thumb {\n  background-color: var(--color-brand-500, #4318FF);\n  /* thumb color */\n  border-radius: 0px;\n  /* creates padding effect */\n}\n\n/* Scrollbar thumb hover */\n.slidebar-scroller::-webkit-scrollbar-thumb:hover {\n  background-color: color-mix(in srgb, var(--color-brand-500, #422AFB) 80%, transparent);\n}\n\n/* ─── Global scrollbar styling ─────────────────────────────────────────────── */\n/* Applies to the main window (html/body) and all scroll containers */\n\n/* Width */\nhtml::-webkit-scrollbar,\nbody::-webkit-scrollbar,\n* ::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n/* Track */\nhtml::-webkit-scrollbar-track,\nbody::-webkit-scrollbar-track,\n* ::-webkit-scrollbar-track {\n  background: var(--color-scrollbar-track, #F4F7FE);\n  border-radius: 10px;\n}\n\n/* Thumb */\nhtml::-webkit-scrollbar-thumb,\nbody::-webkit-scrollbar-thumb,\n* ::-webkit-scrollbar-thumb {\n  background-color: var(--color-scrollbar-thumb, #a3aed0);\n  border-radius: 10px;\n  border: 2px solid var(--color-scrollbar-track, #F4F7FE);\n}\n\n/* Thumb hover */\nhtml::-webkit-scrollbar-thumb:hover,\nbody::-webkit-scrollbar-thumb:hover,\n* ::-webkit-scrollbar-thumb:hover {\n  background-color: var(--color-scrollbar-thumb-hover, #422AFB);\n}\n\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--color-scrollbar-thumb, #a3aed0) var(--color-scrollbar-track, #F4F7FE);\n}\n\n/* Smooth theme transitions */\nbody,\ndiv,\nheader,\nnav,\naside,\nmain,\nsection,\nfooter,\nbutton,\na,\nspan,\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\ninput,\nselect,\ntextarea {\n  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n}\n\n/* Premium micro-interactions: hover effects for themed/contained buttons */\nbutton,\n.MuiButton-root {\n  transition: filter 0.15s ease-in-out, transform 0.1s ease-in-out, background-color 0.15s ease-in-out !important;\n}\n\nbutton:hover,\n.MuiButton-root:hover {\n  filter: brightness(0.94) contrast(1.05);\n}\n\n.dark button:hover,\n.dark .MuiButton-root:hover {\n  filter: brightness(1.08) contrast(1.05);\n}\n\n/* Secondary action buttons need light labels on dark surfaces. */\n.dark button.bg-surfaceSecondary,\n.dark button.bg-lightPrimary {\n  color: var(--color-text-primary, #f8fafc) !important;\n}\n\n.dark button.bg-surfaceSecondary svg,\n.dark button.bg-lightPrimary svg {\n  color: var(--color-text-primary, #f8fafc) !important;\n}\n\nbutton:active,\n.MuiButton-root:active {\n  transform: scale(0.98);\n}\n\n/* Style MUI DataGrid dropdowns, panels, columns, filters, density, and export menus */\n.MuiPaper-root,\n.MuiPopover-paper,\n.MuiMenu-paper,\n.MuiDataGrid-panel {\n  background-color: var(--color-surface-primary, #ffffff) !important;\n  color: var(--color-text-primary, #1b2559) !important;\n  box-shadow: 0px 4px 20px var(--color-shadow-secondary, rgba(112, 144, 176, 0.15)) !important;\n  border: 1px solid var(--color-shadow-secondary, rgba(112, 144, 176, 0.1)) !important;\n}\n\n/* List items / Menu options */\n.MuiMenuItem-root,\n.MuiListItem-root,\n.MuiListItemText-root,\n.MuiButtonBase-root.MuiMenuItem-root {\n  color: var(--color-text-primary, #1b2559) !important;\n}\n\n.MuiMenuItem-root:hover,\n.MuiListItemButton-root:hover {\n  background-color: var(--color-surface-secondary, #F4F7FE) !important;\n}\n\n.MuiMenuItem-root.Mui-selected {\n  background-color: var(--color-brand-50, #E9E3FF) !important;\n  color: var(--color-brand-700, #422AFB) !important;\n}\n\n/* Input fields & Select elements inside filters */\n.MuiPaper-root .MuiInputBase-root,\n.MuiPaper-root .MuiInput-root,\n.MuiPaper-root .MuiNativeSelect-select,\n.MuiPaper-root .MuiSelect-select,\n.MuiPaper-root .MuiInputBase-input {\n  color: var(--color-text-primary, #1b2559) !important;\n}\n\n.MuiPaper-root .MuiInput-underline:before {\n  border-bottom-color: var(--color-shadow-secondary, rgba(0, 0, 0, 0.12)) !important;\n}\n\n.MuiPaper-root .MuiInput-underline:hover:not(.Mui-disabled):before {\n  border-bottom-color: var(--color-text-secondary, #707eae) !important;\n}\n\n/* Labels */\n.MuiPaper-root .MuiFormLabel-root,\n.MuiPaper-root .MuiInputLabel-root {\n  color: var(--color-text-secondary, #707eae) !important;\n}\n\n/* Icons inside popovers/menus */\n.MuiPaper-root .MuiSvgIcon-root,\n.MuiDataGrid-panel .MuiSvgIcon-root {\n  color: var(--color-text-secondary, #707eae) !important;\n}\n\n/* Buttons inside popovers/menus (like Columns show/hide, Filters clear/add) */\n.MuiPaper-root .MuiButton-root,\n.MuiDataGrid-panel .MuiButton-root {\n  color: var(--color-brand-500, #422AFB) !important;\n}\n\n.MuiPaper-root .MuiButton-root:hover,\n.MuiDataGrid-panel .MuiButton-root:hover {\n  background-color: var(--color-brand-50, #E9E3FF) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
